import React, { memo, useMemo } from 'react';

import { Container, IStyled } from './styles';
import * as icons from './icons';

export type TCIconsName = keyof typeof icons;
export type TPositions =
  | 'top'
  | 'top-left'
  | 'top-right'
  | 'center'
  | 'center-right'
  | 'center-left'
  | 'bottom'
  | 'bottom-right'
  | 'bottom-left';

interface IProps extends Omit<IStyled, 'Cpos'> {
  icon: TCIconsName;
  position?: TPositions;
  className?: string;
}

const CustomIconComp: React.FC<IProps> = ({
  icon,
  color,
  size,
  position,
  $noSphere,
  className,
}) => {
  const Icon = useMemo(() => icons[icon], [icon]);
  const pos = useMemo(() => {
    let cssPos = '';

    // if (position?.match('top')) {
    //   cssPos = 'top: 13%;';
    // } else if (position?.match('center')) {
    //   cssPos = 'top: 50%;';
    // } else {
    //   cssPos = 'top: 75%;';
    // }
    if (position?.match('left')) {
      cssPos = `
        ${cssPos}
        right: 0;
      `;
      // } else if (position?.match('right')) {
      //   cssPos = `
      //     ${cssPos}
      //     right: -70%;
      //   `;
    }
    //  else {
    //   cssPos = `
    //     ${cssPos}
    //     left: 50%;
    //   `;
    // }
    return cssPos;
  }, [position]);

  return (
    <Container className={className} $noSphere={$noSphere} color={color} $Cpos={pos} size={size}>
      <Icon />
    </Container>
  );
};

export const CustomIcon = memo(CustomIconComp);
